export class Action {
    constructor(
        public workoutId: string,
        public color: string,
        public description: string,
        public title?: string,        
        public id?: string,
    ) { }
}